export const home = {
  // Hero Section
  title: 'MakanTak',
  tagline: '分享赚奖励，每餐都省钱。',
  subtitle: '马来西亚餐厅推荐奖励平台。',
  getStarted: '立即加入',
  login: '登录',
  demo: '演示',
  
  // Features
  feature1Title: '保证5%折扣',
  feature1Desc: '首次光顾任何参与餐厅即可获得5%即时折扣。无附加条件。',
  feature1Badge: '首次光顾奖励',
  
  feature2Title: '分享赚奖励',
  feature2Desc: '与朋友分享您的专属推荐码。每次他们用餐时，您将获得其账单1%的虚拟货币。',
  feature2Badge: '3级奖励系统',
  
  feature3Title: '兑换奖励',
  feature3Desc: '使用您赚取的虚拟货币支付餐费。最多可抵扣账单的20%。',
  feature3Badge: '最高20%抵扣',
  
  // Merchant CTA
  merchantTitle: '经营餐厅？',
  merchantSubtitle: '加入MakanTak，让您的顾客成为品牌大使。通过我们的推荐系统，只为实际效果付费。',
  merchantPoint1: '最高8%营销成本 - 仅在顾客用餐时付费',
  merchantPoint2: '建立您自己的顾客推荐网络',
  merchantPoint3: '通过实时分析仪表板追踪投资回报率',
  merchantCTA: '与我们合作',
  
  // About Section
  aboutTitle: '为什么选择MakanTak？',
  aboutSubtitle: '我们正在通过口碑营销革新马来西亚餐厅的业务增长方式。',
  
  aboutCard1Title: '社区驱动',
  aboutCard1Desc: '专为马来西亚本地餐厅及其忠实顾客打造。我们相信通过真实推荐共同成长。',
  
  aboutCard2Title: '按效果付费',
  aboutCard2Desc: '无预付费用。餐厅仅在顾客实际用餐时付费。透明、可衡量、对所有人公平。',
  
  aboutCard3Title: '安全合规',
  aboutCard3Desc: '符合PDPA标准，具备强大的安全措施。您的数据受到保护，隐私是我们的首要任务。',
  
  // Footer
  footerTagline: '分享优惠，共建社区。',
  footerDesc: '马来西亚本地餐厅推荐奖励平台。',
  forCustomers: '顾客专区',
  forRestaurants: '餐厅专区',
  company: '公司',
  demoLink: '演示仪表板',
  faqLink: '常见问题',
  merchantEnquiry: '商家咨询',
  aboutUs: '关于我们',
  contact: '联系我们',
  privacy: '隐私政策',
  terms: '服务条款',
  copyright: '© 2026 MakanTak. 版权所有。',
  followUs: '在X上关注我们',
};
